(function(){
    'use strict';
    angular.module('mso.registration').controller('RegisterCompleteDeactivatedCtrl', RegisterCompleteDeactivatedCtrl);

    RegisterCompleteDeactivatedCtrl.$inject = ['referenceData'];
    function RegisterCompleteDeactivatedCtrl(referenceData){
        var vm = this;

        // Initialise configuration items
        vm.messages = referenceData.messages;
        vm.parameters = referenceData.parameters;
        vm.referenceData = referenceData;
        vm.title = 'User deactivated';
        vm.vs = referenceData.valuesets;
    }
})();